import { Dispatch } from 'redux';
import { PricingApi } from '../../../api/api.apiclient';
import { GET_CORE_CACHE_STATUS, GET_RATE_CACHE_STATUS, RatecacheStatusActionTypes } from '../types/rateCacheStatus.types';

export const getRateCacheStatus = () => async (dispatch: Dispatch<RatecacheStatusActionTypes>) => {
  try {
    const response = await PricingApi.cacheStatus.getRateCacheStatus();

    dispatch({
      type: GET_RATE_CACHE_STATUS,
      payload: {
        rateCacheStatus: response.data
      }
    });
  } catch (e) {
    dispatch({
      type: GET_RATE_CACHE_STATUS,
      payload: {
        rateCacheStatus: null
      }
    });
  }
};

export const getCoreCacheStatus = () => async (dispatch: Dispatch<RatecacheStatusActionTypes>) => {
  try {
    const response = await PricingApi.cacheStatus.getCoreRateCacheStatus();

    dispatch({
      type: GET_CORE_CACHE_STATUS,
      payload: {
        coreCacheStatus: response.data
      }
    });
  } catch (e) {
    dispatch({
      type: GET_CORE_CACHE_STATUS,
      payload: {
        coreCacheStatus: null
      }
    });
  }
};
